import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import { Bar } from 'react-chartjs-2'
import moment from 'moment'

import { withStyles } from '@material-ui/core/styles'
import { styles } from '../../classes/Styles'
import { TRACKER_BENCHMARK1, TRACKER_BENCHMARK2, TRACKER_BENCHMARK3, TRACKER_BENCHMARK4, TRACKER_PRIMARY } from '../../constants/colors'

export class LaunchBar extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    screenWidth: PropTypes.number,
    trackerPlan: PropTypes.object,
    trackerAverageBenchMarkPlan: PropTypes.object,
    trackerData: PropTypes.array,
    primarySelect: PropTypes.object,
    benchmarkSelect1: PropTypes.object,
    benchmarkSelect2: PropTypes.object,
    benchmarkSelect3: PropTypes.object,
    benchmarkSelect4: PropTypes.object,
    averageBenchmarkSelect: PropTypes.object,
    maxLaunchValue: PropTypes.number,
    handleMaxLaunchValue: PropTypes.func
  }

  componentDidMount () {
    this.setupTrackerData ()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.trackerAverageBenchMarkPlan != this.props.trackerAverageBenchMarkPlan && prevProps.trackerPlan != this.props.trackerPlan && this.props.trackerPlan.details || prevProps.primarySelect != this.props.primarySelect || prevProps.benchmarkSelect1 != this.props.benchmarkSelect1 || prevProps.benchmarkSelect2 != this.props.benchmarkSelect2 || prevProps.benchmarkSelect3 != this.props.benchmarkSelect3 || prevProps.benchmarkSelect4 != this.props.benchmarkSelect4) {
      this.setupTrackerData ()
    }
  }

  setupTrackerData () {
    const { primarySelect, benchmarkSelect1, benchmarkSelect2, benchmarkSelect3, benchmarkSelect4, averageBenchmarkSelect } = this.props
    const val = [
      primarySelect && primarySelect.dayZeroData || 0,
      benchmarkSelect1 && benchmarkSelect1.dayZeroData || 0,
      benchmarkSelect2 && benchmarkSelect2.dayZeroData || 0,
      benchmarkSelect3 && benchmarkSelect3.dayZeroData || 0,
      benchmarkSelect4 && benchmarkSelect4.dayZeroData || 0,
      averageBenchmarkSelect && averageBenchmarkSelect.dayZeroData || 0
    ]
    const maxVal = Math.max.apply(Math, val)
    const maxValue = maxVal <= 5 ? 5
    : Math.ceil(maxVal/10) * 10
    this.props.handleMaxLaunchValue(maxValue)
  }

  render () {
    const { screenWidth, trackerPlan, primarySelect, benchmarkSelect1, benchmarkSelect2, benchmarkSelect3, benchmarkSelect4, averageBenchmarkSelect, maxLaunchValue, trackerAverageBenchMarkPlan } = this.props
    const averageBenchMark = trackerAverageBenchMarkPlan && trackerAverageBenchMarkPlan.details && trackerAverageBenchMarkPlan.details.average_bench_mark
    const averageBenchMarkMetrics = averageBenchMark && averageBenchMark.metrics
    const averageBenchMarkDayZero = averageBenchMarkMetrics && averageBenchMarkMetrics.filter(b => b.day === 0)
    const averageBenchMarkMax = averageBenchMarkMetrics && averageBenchMarkDayZero.length > 0 ? averageBenchMarkDayZero[0].max : 0
    const averageBenchMarkMin = averageBenchMarkMetrics && averageBenchMarkDayZero.length > 0 ? averageBenchMarkDayZero[0].min : 0
    let benchmarks = trackerPlan.details && trackerPlan.details.benchmarks
    benchmarks = benchmarks.length > 0 ? benchmarks.filter(b => b.is_default_benchmark) : benchmarks
    const primaryTracker = trackerPlan.details && trackerPlan.details.primary_tracker
    const showPrimaryEntity = primarySelect && moment(new Date()).diff(moment(new Date(primarySelect.lookbackDate)), 'days') > -1 ? true : false
    const showBenchmarkMax1 = benchmarkSelect1 && moment(new Date()).diff(moment(new Date(benchmarkSelect1.lookbackDate)), 'days') > -1 ? true : false
    const showBenchmarkMax2 = benchmarkSelect2 && moment(new Date()).diff(moment(new Date(benchmarkSelect2.lookbackDate)), 'days') > -1 ? true : false
    const showBenchmarkMax3 = benchmarkSelect3 && moment(new Date()).diff(moment(new Date(benchmarkSelect3.lookbackDate)), 'days') > -1 ? true : false
    const showBenchmarkMax4 = benchmarkSelect4 && moment(new Date()).diff(moment(new Date(benchmarkSelect4.lookbackDate)), 'days') > -1 ? true : false
    let trackerMetricsArr = []
    let maxArr = []
    if (primaryTracker && primaryTracker.metrics) {
      for (let i =0; i < primaryTracker.metrics.length; i++) {
        trackerMetricsArr.push(primaryTracker.metrics[i].value)
      }
      maxArr.push(Math.max.apply(null, trackerMetricsArr))
    }

    let averageBenchMarks = trackerAverageBenchMarkPlan.details ? trackerAverageBenchMarkPlan.details.average_bench_mark : {}
    let averageBenchMarkArr = []
    if (averageBenchMarks && averageBenchMarks.metrics) {
      for (let index =0; index < averageBenchMarks.metrics.length; index++) {
        averageBenchMarkArr.push(averageBenchMarks.metrics[index].max)
      }
      maxArr.push(Math.max.apply(null, averageBenchMarkArr))
    }

    for (let j = 0; j < benchmarks.length; j++) {
      if (benchmarks && benchmarks[j].metrics) {
        let benchMarkArr = []
        for (let benchMarkIndex = 0; benchMarkIndex < benchmarks[j].metrics.length; benchMarkIndex++) {
          benchMarkArr.push(benchmarks[j].metrics[benchMarkIndex].value)
        }
        maxArr.push(Math.max.apply(null, benchMarkArr))
      }
    }

    //let maxValue = Math.max.apply(null, maxArr)
    const val = [
      primarySelect && primarySelect.dayZeroData || 0,
      benchmarkSelect1 && benchmarkSelect1.dayZeroData || 0,
      benchmarkSelect2 && benchmarkSelect2.dayZeroData || 0,
      benchmarkSelect3 && benchmarkSelect3.dayZeroData || 0,
      benchmarkSelect4 && benchmarkSelect4.dayZeroData || 0,
      averageBenchmarkSelect && averageBenchmarkSelect.dayZeroData || 0
    ]
    const maxVal = Math.max.apply(Math, val)
    var maxValue = maxVal <= 5 ? 5
    : Math.ceil(maxVal/10) * 10

    const updateChartTicks = (scale, that) => { // Function to setting max Y-axis value and keeping steps correct
      var incrementAmount = 0
      var previousAmount = 0
      var newTicks = []
      newTicks = scale.ticks
      for (var x=0; x<newTicks.length; x++) {
        incrementAmount = (previousAmount - newTicks[x])
        previousAmount = newTicks[x]
      }
      if (newTicks.length > 2) {
        if (newTicks[0] - newTicks[1] != incrementAmount) {
          var tick = newTicks[0]
          newTicks[0] = newTicks[1] + incrementAmount
          if (tick > newTicks[0]) {
            newTicks.unshift(newTicks[0] + incrementAmount, 0)
          }
          maxValue = newTicks[0] //newTicks[1] + incrementAmount
          that.props.handleMaxLaunchValue(maxValue)
        }
      }
      return newTicks
    }

    const data = {
      labels: ['Launch'],
      datasets: [
        {
          label: 'Avg1',
          type: 'scatter',
          fill: false,
          showLine: false,
          backgroundColor: TRACKER_PRIMARY,
          borderColor: TRACKER_PRIMARY,
          data: showPrimaryEntity && primarySelect ? primarySelect.dayZeroData : [],
          stack: 'Stack 1',
          pointStyle: 'rectRot', //this is to show diamond shape scatter in the bar chart
          radius: 4
        },
        {
          label: 'Avg2',
          type: 'scatter',
          fill: false,
          showLine: false,
          backgroundColor: TRACKER_BENCHMARK1,
          borderColor: TRACKER_BENCHMARK1,
          data: showBenchmarkMax1 && benchmarkSelect1 ? benchmarkSelect1.dayZeroData : [],
          stack: 'Stack 1',
          pointStyle: 'rectRot',
          radius: 4
        },
        {
          label: 'Avg3',
          type: 'scatter',
          fill: false,
          showLine: false,
          backgroundColor: TRACKER_BENCHMARK2,
          borderColor: TRACKER_BENCHMARK2,
          data: showBenchmarkMax2 && benchmarkSelect2 ? benchmarkSelect2.dayZeroData : [],
          stack: 'Stack 1',
          pointStyle: 'rectRot',
          radius: 4
        },
        {
          label: 'Avg4',
          type: 'scatter',
          fill: false,
          showLine: false,
          backgroundColor: TRACKER_BENCHMARK3,
          borderColor: TRACKER_BENCHMARK3,
          data: showBenchmarkMax3 && benchmarkSelect3 ? benchmarkSelect3.dayZeroData : [],
          stack: 'Stack 1',
          pointStyle: 'rectRot', //this is to show diamond shape scatter in the bar chart
          radius: 4
        },
        {
          label: 'Avg5',
          type: 'scatter',
          fill: false,
          showLine: false,
          backgroundColor: TRACKER_BENCHMARK4,
          borderColor: TRACKER_BENCHMARK4,
          data: showBenchmarkMax4 && benchmarkSelect4 ? benchmarkSelect4.dayZeroData : [],
          stack: 'Stack 1',
          pointStyle: 'rectRot',
          radius: 4
        },
        {
          label: 'LaunchMin',
          backgroundColor: '#FFFFFF',
          data: averageBenchmarkSelect && averageBenchmarkSelect.data.length > 0 ? [averageBenchMarkMin] : [],
          stack: 'Stack 1',
          fill: false,
          barThickness: 25
        },
        {
          label: 'LaunchMax',
          backgroundColor: (context) => {
            const ctx = context.chart.ctx
            const gradient = ctx.createLinearGradient(0, 0, 0, context.chart.height ? context.chart.height : 200)
            gradient.addColorStop(0, 'rgba(255, 183, 0, 0.4)')
            gradient.addColorStop(1, 'rgba(255, 183, 0, 0.1)')
            return gradient
          },
          data: averageBenchmarkSelect && averageBenchmarkSelect.data.length > 0 ? [averageBenchMarkMax - averageBenchMarkMin] : [],
          stack: 'Stack 1',
          fill: '+1',
          barThickness: 25
        }
      ]
    }

    const that = this
    const options = {
      maintainAspectRatio: true,
      responsive: true,
      legend: {
        display: false
      },
      tooltips: {
        enabled: false
      },
      scales: {
        yAxes: [{
          position: 'right',
          afterBuildTicks: function (scale) {
            scale.ticks = updateChartTicks(scale, that)
          },
          ticks: {
            display: true,
            fontColor: '#A7A9AC',
            fontFamily: 'Uni Sans Regular',
            max: maxLaunchValue,
            min: 0,
            stepSize: maxLaunchValue <= 5 ? 1
            : maxLaunchValue <= 10 ? 2
            : maxLaunchValue <= 20 ? 5
            : maxLaunchValue <= 30 ? 5
            : maxLaunchValue <= 40 ? 10
            : maxLaunchValue <= 50 ? 10
            : maxLaunchValue <= 100 ? 20
            : maxLaunchValue <= 300 ? 50
            : maxLaunchValue <= 1000 ? 100
            : maxLaunchValue <= 3000 ? 200
            : maxLaunchValue <= 5000 ? 500
            : maxLaunchValue <= 10000 ? 1000
            : maxLaunchValue <= 20000 ? 2000 : 5000,
            callback: function (label) {
              if (label >= 1000) {
                const lbl = label / 1000
                const lblR = label % 1000
                const val = lblR === 0 ? `${lbl}k` : lblR % 100 === 0 ? //lblR + 1000
                `${Math.trunc(lbl)}.${Math.round(lblR / 100)}k`
                : `${Math.trunc(lbl)}.${Math.round(lblR / 100)}k`
                return val
              } else if (label >= 100) {
                const lbl = label / 100
                const lblR = label % 100
                return lblR === 0 ? `${lbl}00` : lblR === 50 ? `${Math.trunc(lbl)}50` : ''//`${Math.round(lbl)}00`
              } else if (label > 30 && label < 100) {
                const lbl = label / 10
                const lblR = label % 10
                return lblR === 0 ? `${lbl}0` : `${Math.round(lbl)}0`
              }
              return label
            }
          },
          stacked: true,
          gridLines: {
            display: true,
            drawBorder: false
          }
        }],
        xAxes: [{
          //barThickness: 25,
          gridLines: {
            display: false
          },
          ticks: {
            fontColor: '#A7A9AC'
          },
          stacked: true
        }]
      }
    }

    return (
      <Grid>
        <Bar data={data} options={options} width={screenWidth >= 480 ? 24 : 24} height={screenWidth >= 480 ? 84 : 168}/>
      </Grid>
    )
  }
}

export default withStyles(styles)(LaunchBar)